const repo = {
  skip: 0,
  limit: 20,
  endpoint: process.env.VUE_APP_CIRCL_V2
}

export default repo
